import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities, SecondaryColors, SurfaceColors } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& $navArrow': {
      color: TextColors.light,

      '&:disabled': {
        color: hexToRGBA(TextColors.light, TextOpacities.light3),
      },
    },

    '& $tabs': {
      color: TextColors.light,

      '& .MuiTabs-indicator': {
        backgroundColor: SecondaryColors.main,
      },
    },

    '& $tab': {
      backgroundColor: SurfaceColors.dark,

      '&.MuiTab-textColorInherit': {
        color: hexToRGBA(TextColors.light, TextOpacities.dark2),

        '&.Mui-selected, &:hover': {
          color: TextColors.light,
        },
      },
    },
  },
};

const lightTheme = {
  root: {
    '& $navArrow': {
      color: TextColors.dark,

      '&:disabled': {
        color: hexToRGBA(TextColors.dark, TextOpacities.dark3),
      },
    },

    '& $tabs': {
      color: TextColors.dark,

      '& .MuiTabs-indicator': {
        backgroundColor: SecondaryColors.dark,
      },
    },

    '& $tab': {
      backgroundColor: SurfaceColors.light,

      '&.MuiTab-textColorInherit': {
        color: hexToRGBA(TextColors.dark, TextOpacities.dark2),

        '&.Mui-selected, &:hover': {
          color: TextColors.dark,
        },
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    '@keyframes enter': {
      '0%': {
        opacity: 0,
      },
      '100%': {
        opacity: 1,
      },
    },

    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
    },

    nextArrow: {},
    prevArrow: {},
    navArrow: {
      display: 'flex',
    },

    tabs: {
      position: 'relative',
      display: 'inline-flex',
      margin: '40px 0 0 -32px',
      width: 'calc(100% + 64px)',

      [muiTheme.breakpoints.up('md')]: {
        margin: '48px 0 0 -32px',
      },

      '& .MuiTabs-flexContainer': {
        position: 'relative',
        zIndex: 1,
      },

      '& .MuiTabs-scrollButtons': {
        width: '32px',
      },

      '& .MuiTabs-indicator': {
        height: '3px',
        zIndex: 1,
      },
    },

    tab: {
      '&.MuiButtonBase-root': {
        position: 'relative',
        borderRadius: '4px',
        whiteSpace: 'nowrap',
        padding: 0,
        paddingTop: 'calc(33.333333333% - 16px)',
        width: 'calc(33.333333333% - 16px)',

        [muiTheme.breakpoints.up('sm')]: {
          width: 'calc(25% - 18px)',
          paddingTop: 'calc(24% - 18px)',
        },
        [muiTheme.breakpoints.up('md')]: {
          width: 'calc(20% - 19.2px)',
          paddingTop: 'calc(20% - 19.2px)',
        },

        '&:not(:last-child)': {
          marginRight: muiTheme.spacing(3),
        },

        '&.Mui-selected': {
          borderRadius: '4px 4px 0 0',
        },

        '&:not(.Mui-selected)': {
          '& picture': {
            opacity: 0.5,
          },
        },

        '&.MuiTab-textColorInherit': {
          opacity: 1,
        },

        '& picture': {
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
        },
      },
    },
  }),
  { name: 'GenImageGallerySliderWithTabs' },
);

export default useStyles;
